/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import NoteHtml from 'DesignSystem/NoteHtml/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/TreatmentNoteRow/Content/Content"
  
}) {
let noteNoteValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'note',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<NoteHtml
  viewPath={`${viewPath}/NoteHtml`}
 data="note.note"
 html={noteNoteValueData}
/>
</div>
{children}
</React.Fragment>)
}